import Button from '@mui/material/Button';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { useTranslation } from 'react-i18next';
import FattyCartDrawer from '../../../../../apps/table-tuck-web/src/app/components/fattyCartDrawer';
import { environment } from '../../../../../apps/table-tuck-web/src/environments/environment';
import { getFontFamily } from '../../../../../apps/table-tuck-web/src/app/Utils/fontLoader';

export function FattyPattyAnonymousUser({
  counter,
  openCartDialoge,
  onHoverCart,
  onHoverLeaveCart,
  handleCloseCartDialoge,
  userData,
  navigate,
  mdDown,
  isCheckoutPage = false,
  isIOS = false,
}) {
  const { t } = useTranslation();

  const cartIcon = (extraStyle = {}) =>
    !isCheckoutPage && (
      <>
        <div
          style={{
            border: '1px solid #FFFFFF66',
            background: 'transparent',
            borderRadius: '50%',
            width: '45px',
            height: '45px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            position: 'relative',
            ...extraStyle,
          }}
          onClick={() => navigate('/cart')}
          onMouseEnter={onHoverCart}
          onMouseLeave={onHoverLeaveCart}
        >
          <ShoppingCartIcon style={{ color: 'white', fontSize: '20px' }} />
          {counter > 0 && (
            <div
              style={{
                position: 'absolute',
                top: '-5px',
                right: '-5px',
                backgroundColor: '#FF6B6B',
                borderRadius: '50%',
                width: '20px',
                height: '20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '12px',
                color: 'white',
                fontWeight: 'bold',
              }}
            >
              {counter}
            </div>
          )}
        </div>
        {openCartDialoge && !isIOS && (
          <FattyCartDrawer
            openCartDialoge={openCartDialoge}
            handleCloseCartDialoge={handleCloseCartDialoge}
            userData={userData}
          />
        )}
      </>
    );

  return (
    <>
      {/* Mobile: Sign In button first, then cart */}
      {mdDown && (
        <>
          <Button
            onClick={() => navigate('/signup')}
            style={{
              border: '2px solid white',
              color: 'white',
              backgroundColor: 'transparent',
              borderRadius: '52px',
              borderColor: 'white',
              width: '100px',
              fontFamily: getFontFamily(environment?.restaurantId, 'jost'),
              fontWeight: 700,
              height: '36px',
              fontSize: '12px',
              textTransform: 'none',
              marginLeft: '8px',
            }}
          >
            {t('signIn')}
          </Button>
          {cartIcon({ marginLeft: '8px' })}
        </>
      )}

      {/* Desktop: Cart first, then Sign In and Order Now buttons */}
      {!mdDown && (
        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
          {cartIcon()}
          <div style={{ display: 'flex', gap: '10px' }}>
            <Button
              onClick={() => navigate('/signup')}
              style={{
                border: '2px solid white',
                color: 'white',
                backgroundColor: 'transparent',
                borderRadius: '52px',
                borderColor: 'white',
                width: '126px',
                fontFamily: getFontFamily(environment?.restaurantId, 'jost'),
                fontWeight: 700,
                height: '38px',
                fontSize: '14px',
                textTransform: 'none',
                marginLeft: '10px',
              }}
            >
              {t('signIn')}
            </Button>
            <Button
              onClick={() => navigate('/menu')}
              style={{
                backgroundColor: 'white',
                color: environment.mainColor,
                borderRadius: '52px',
                width: '126px',
                fontFamily: getFontFamily(environment?.restaurantId, 'jost'),
                fontWeight: 700,
                height: '38px',
                fontSize: '14px',
                textTransform: 'none',
              }}
            >
              {t('orderNow')}
            </Button>
          </div>
        </div>
      )}
    </>
  );
}

export default FattyPattyAnonymousUser;
